import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ImageTwoColsBlockConfig } from '@front-platform/content-builder';
import { imageTwoColsBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';

import { IContentBuilderFieldImage } from '@core/models/content-builder-fields.model';
export interface ImageTwoColsBlockRuntimeConfig {}

export type ImageTwoColsBlockConfigInput = Partial<
  Omit<ImageTwoColsBlockConfig, keyof ImageTwoColsBlockRuntimeConfig> &
    ImageTwoColsBlockRuntimeConfig
>;
export type ImageTwoColsBlockResolvedConfig = Omit<
  ImageTwoColsBlockConfig,
  keyof ImageTwoColsBlockRuntimeConfig
> &
  Partial<ImageTwoColsBlockRuntimeConfig>;
export interface ImageTwoColsBlockContract extends ConfigComponentContract<
  ImageTwoColsBlockConfigInput,
  ImageTwoColsBlockResolvedConfig
> {}

@Component({
  selector: 'app-image-two-cols-block',
  templateUrl: './image-two-cols-block.component.html',
  standalone: false,
})
export class ImageTwoColsBlockComponent implements ImageTwoColsBlockContract {
  readonly config = input<ImageTwoColsBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ImageTwoColsBlockConfig,
    ImageTwoColsBlockRuntimeConfig
  >(imageTwoColsBlockResolveConfig, () => ({ config: this.config() }));
  get imageLeft(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['image_left'] as unknown as IContentBuilderFieldImage | undefined;
  }
  get imageRight(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['image_right'] as unknown as IContentBuilderFieldImage | undefined;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ImageTwoColsBlockComponent, { 'keyAliases': {} });
